// src/plugins/axios.js
import axios from "axios";
import constant from "../constant";
export default {
  install(Vue) {
    // Create an Axios instance
    const instance = axios.create({
      baseURL: process.env.VUE_APP_API_URL || "https://api5.peascom.ma",
      timeout: 10000,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest", // Ensure this is added
      },
    });

    // Add request interceptor to inject Authorization header
    instance.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem(constant.authToken);
        if (token) {
          config.headers["Authorization"] = `Bearer ${token.replaceAll(
            '"',
            ""
          )}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Gestion des réponses (inchangé)
    instance.interceptors.response.use(
      (response) => response,
      (error) => Promise.reject(error)
    );

    // ... (tes méthodes fetch, show, create, etc.)

    // Exemple d'utilisation constante pour set user role
    window.addEventListener("storage", (event) => {
      if (event.key === constant.userRoleKey) {
        store.commit("SET_USER_ROLE", event.newValue);
      }
    });

    // Attach helper methods to Vue prototype
    Vue.prototype.$api = {
      async show(url) {
        Vue.prototype.$loading.start();
        try {
          const response = await instance.get(url);
          return response;
        } catch (error) {
          console.error("API Show Error:", error);
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Une erreur est survenue lors de la récupération des données.";
          Vue.prototype.$toast.error(errorMessage);
          throw error;
        } finally {
          Vue.prototype.$loading.stop();
        }
      },
      async fetch(url, params = {}) {
        Vue.prototype.$loading.start();
        try {
          const response = await instance.get(url, { params });
          return response.data;
        } catch (error) {
          console.error("API Fetch Error:", error);
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Une erreur est survenue lors du chargement des données.";
          Vue.prototype.$toast.error(errorMessage);
          throw error;
        } finally {
          Vue.prototype.$loading.stop();
        }
      },

      // async create(url, data) {
      //   Vue.prototype.$loading.start();
      //   try {
      //     const response = await instance.post(url, data);

      //     // Show success message based on response.data.status
      //     if (response.data.status) {
      //       Vue.prototype.$toast.success(response.data.message);
      //     }

      //     return response;
      //   } catch (error) {
      //     console.error("API Create Error:", error);
      //     const errorMessage =
      //       error.response && error.response.data && error.response.data.message
      //         ? error.response.data.message
      //         : "Une erreur est survenue lors de la création.";
      //     Vue.prototype.$toast.error(errorMessage);
      //     throw error;
      //   } finally {
      //     Vue.prototype.$loading.stop(); // Uncomment this line to stop loading
      //   }
      // },

      // async update(url, data) {
      //   Vue.prototype.$loading.start();
      //   try {
      //     const response = await instance.put(url, data);
      //     if (response.data.status) {
      //       Vue.prototype.$toast.success(response.data.message);
      //     }
      //     return response;
      //   } catch (error) {
      //     console.error("API Update Error:", error);
      //     const errorMessage =
      //       error.response && error.response.data && error.response.data.message
      //         ? error.response.data.message
      //         : "Une erreur est survenue lors de la mise à jour.";
      //     Vue.prototype.$toast.error(errorMessage);
      //     throw error;
      //   } finally {
      //     Vue.prototype.$loading.stop();
      //   }
      // },
      // async delete(url) {
      //   Vue.prototype.$loading.start();
      //   try {
      //     const response = await instance.delete(url);
      //     if (response.data.status) {
      //       Vue.prototype.$toast.success(response.data.message);
      //     }
      //     return response;
      //   } catch (error) {
      //     console.error("API Delete Error:", error);
      //     const errorMessage =
      //       error.response && error.response.data && error.response.data.message
      //         ? error.response.data.message
      //         : "Une erreur est survenue lors de la suppression.";
      //     Vue.prototype.$toast.error(errorMessage);
      //     throw error;
      //   } finally {
      //     Vue.prototype.$loading.stop();
      //   }
      // },

      /*async create(url, data) {
        const confirmed = await Vue.prototype.$confirm({
          title: "Confirmation",
          message: "Voulez-vous vraiment créer cet élément ?",
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
        });

        if (!confirmed) return;

        Vue.prototype.$loading.start();
        try {
          const response = await instance.post(url, data);

          if (response.data.status) {
            Vue.prototype.$toast.success(response.data.message);
          }

          return response;
        } catch (error) {
          console.error("API Create Error:", error);
          const errorMessage =
            error.response.data.message ||
            "Une erreur est survenue lors de la création.";
          Vue.prototype.$toast.error(errorMessage);
          throw error;
        } finally {
          Vue.prototype.$loading.stop();
        }
      },

      async update(url, data) {
        const confirmed = await Vue.prototype.$confirm({
          title: "Confirmation",
          message: "Voulez-vous vraiment modifier cet élément ?",
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
        });

        if (!confirmed) return;

        Vue.prototype.$loading.start();
        try {
          const response = await instance.put(url, data);

          if (response.data.status) {
            Vue.prototype.$toast.success(response.data.message);
          }

          return response;
        } catch (error) {
          console.error("API Update Error:", error);
          const errorMessage =
            error.response.data.message ||
            "Une erreur est survenue lors de la mise à jour.";
          Vue.prototype.$toast.error(errorMessage);
          throw error;
        } finally {
          Vue.prototype.$loading.stop();
        }
      },

      async delete(url) {
        const confirmed = await Vue.prototype.$confirm({
          title: "Confirmation",
          message: "Voulez-vous vraiment supprimer cet élément ?",
          confirmButtonText: "Oui",
          cancelButtonText: "Non",
        });

        if (!confirmed) return;

        Vue.prototype.$loading.start();
        try {
          const response = await instance.delete(url);

          if (response.data.status) {
            Vue.prototype.$toast.success(response.data.message);
          }

          return response;
        } catch (error) {
          console.error("API Delete Error:", error);
          const errorMessage =
            error.response.data.message ||
            "Une erreur est survenue lors de la suppression.";
          Vue.prototype.$toast.error(errorMessage);
          throw error;
        } finally {
          Vue.prototype.$loading.stop();
        }
      },*/

      async create(url, data, options = {}) {
        if (options.confirm !== false) {
          const confirmed = await Vue.prototype.$confirm({
            title: "Confirmation",
            message: "Voulez-vous vraiment créer cet élément ?",
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
          });

          if (!confirmed) return;
        }

        Vue.prototype.$loading.start();
        try {
          const response = await instance.post(
            url,
            data,
            options && !options.confirm ? options : undefined
          );

          if (response.data.status) {
            Vue.prototype.$toast.success(response.data.message);
          }

          return response;
        } catch (error) {
          console.error("API Create Error:", error);
          const errorMessage =
            error.response.data.message ||
            "Une erreur est survenue lors de la création.";
          Vue.prototype.$toast.error(errorMessage);
          throw error;
        } finally {
          Vue.prototype.$loading.stop();
        }
      },

      async update(url, data, options = {}) {
        if (!options.confirm) {
          const confirmed = await Vue.prototype.$confirm({
            title: "Confirmation",
            message: "Voulez-vous vraiment modifier cet élément ?",
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
          });

          if (!confirmed) return;
        }

        Vue.prototype.$loading.start();
        try {
          const response = await instance.put(url, data);

          if (response.data.status) {
            Vue.prototype.$toast.success(response.data.message);
          }

          return response;
        } catch (error) {
          console.error("API Update Error:", error);
          const errorMessage =
            error.response.data.message ||
            "Une erreur est survenue lors de la mise à jour.";
          Vue.prototype.$toast.error(errorMessage);
          throw error;
        } finally {
          Vue.prototype.$loading.stop();
        }
      },

      async delete(url, options = {}) {
        if (!options.confirm) {
          const confirmed = await Vue.prototype.$confirm({
            title: "Confirmation",
            message: "Voulez-vous vraiment supprimer cet élément ?",
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
          });

          if (!confirmed) return;
        }

        Vue.prototype.$loading.start();
        try {
          const response = await instance.delete(url);

          if (response.data.status) {
            Vue.prototype.$toast.success(response.data.message);
          }

          return response;
        } catch (error) {
          console.error("API Delete Error:", error);
          const errorMessage =
            error.response.data.message ||
            "Une erreur est survenue lors de la suppression.";
          Vue.prototype.$toast.error(errorMessage);
          throw error;
        } finally {
          Vue.prototype.$loading.stop();
        }
      },
    };
  },
};
